<template>
  <div class="wk-modal-form">
    <div class="item">
      <div class="title">
        <span>定向包</span>
        <span class="option" @click="handleOpenTargetedPackageDrawer"><i class="el-icon-edit-outline"></i>编辑</span>
      </div>
      <div class="form-body">
        <div class="no-data" v-if=" !(rootFormDataOptions?.app_id?.length || selectOptionData?.packageSelectData?.select?.package_names?.length)" >暂无数据</div>
        <div class="list-data" v-else>
          <template v-if="isUnified">
            <div class="list-data-item" v-for="item in ( selectOptionData?.packageSelectData?.select.package_names || [] )" :key="item">
              <span class="label">{{ selectOptionData?.packageSelectData?.list[item] }}</span>
            </div>
          </template>
         <template v-else>
            <div class="list-data-item" v-for="item in rootFormDataOptions.app_id" :key="item.value">
              <span class="label">{{ item.app_name }}({{ item.show_id }})</span>
                <div class="sub-item" v-for="subItem in ( selectOptionData.packageSelectData?.select?.[item.value] || [])" :key="subItem">
                  <span class="label">{{ selectOptionData.packageSelectData.list[subItem] }}</span>
                </div>
            </div>
         </template>
        </div>
      </div>
    </div>
    <div class="item">
      <div class="title">
        <span>转化出价</span>
        <span class="option" @click="handleOpenConversionDrawer"><i class="el-icon-edit-outline"></i>编辑</span>
      </div>
      <div class="form-body">
        <div class="no-data" v-if="!adPlacementId?.length">暂无数据</div>
        <div class="list-data" v-else>
          <template v-if="isPosition">
            <div class="list-data-item" v-for="item in adPlacementId" :key="item.value">
              <span class="label">{{ item.label }} : {{ item.num }}</span>
            </div>
          </template>
          <template v-else>
            <div class="list-data-item" v-for="item in adPlacementId" :key="item.app_id">
              <span class="label">{{ item.app_name }}({{ item.show_id }})</span>
              <div class="sub-item" v-for="subItem in item.ad_placement_id" :key="subItem.value">
                <span class="label">{{ subItem.label }} : {{ subItem.num }}</span>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="item">
      <div class="title">
        <span>创意组</span>
        <span class="option" @click="handleOpenMaterialDrawer"><i class="el-icon-folder-opened"></i>选择素材</span>
      </div>
      <div class="form-body">
        <div class="no-data" v-if="!ideaList.length">暂无数据</div>
        <div class="list-data" v-else>
          <div class="list-data-item" v-for="item in ideaList" :key="item.label">
            <span class="label">{{ item.app_name }}({{ item.show_id }})</span>
              <div class="sub-item" v-for="subItem in item.ad_placement_id" :key="subItem.value">
                <span class="label">{{ subItem.label }} : {{ subItem.num  }}</span>
              </div>
          </div>
        </div>
        
      </div>
    </div>
    <!-- <div class="item">
      <div class="title">
        <span>广告标题</span>
        <span class="option"><i class="el-icon-circle-plus-outline"></i>添加文案</span>
      </div>
      <div class="form-body">
        <div class="no-data">暂无数据</div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { honorMaterialDrawer, honorConversionDrawer , honorTargetedPackageDrawer} from '../modal/index.js'
import { ADD_TYPE , ADD_PACKAGE_TYPE} from '../constant.js'
import { FILE_TYPE } from '../modal/materialDrawer/constant.js'
import { appList, displayType , config} from './mock.js'
import _ from 'lodash'
export default {
    name: 'WkHonorModalForm',
	data() {
		return {}
	},
	props: {
    rootFormDataOptions: Object,
    rootFormData: Object,
    config: Object,
    value: Array,
		openModalData: {
			type: Object,
			default: () => {
				return {}
			}
		}
	},
  computed: {
    selectOptionData() {
      const [,,, selectData] = this.value || [];
      const { conversionSelectData={}, materialSelectData={}, packageSelectData={} } = selectData || {};
      return { 
        conversionSelectData, 
        materialSelectData, 
        packageSelectData
      }
    },
    addType() {
      const { type }  = this.selectOptionData.conversionSelectData || {};
      return type || ADD_TYPE.POSITION;
    },
    addPackageType() {
      const { type }  = this.selectOptionData.packageSelectData || {};
      return type || ADD_PACKAGE_TYPE.APP;
    },
    displayTypeList() {
      const { ad_placement_id=[] } = this.rootFormDataOptions;
      return ad_placement_id.filter(item=> (this.rootFormData.ad_placement_id || []).includes(item.value));
    },
    allowEdit() {
      const appList = this.rootFormDataOptions.app_id;
      const displayTypeList = this.displayTypeList;
      return appList?.length && displayTypeList?.length;
    },
    isUnified() {
      return this.addPackageType === ADD_PACKAGE_TYPE.UNIFIED;
    },
    isPosition() {
      return this.addType === ADD_TYPE.POSITION;
    },
    adPlacementId() {
      const { app_id=[], ad_placement_id=[] } = this.rootFormDataOptions;
      const selectData = this.selectOptionData.conversionSelectData?.select || {};
      if(this.isPosition) {
        return ad_placement_id.filter(item=> (this.rootFormData.ad_placement_id || []).includes(item.value)).map(item=> ({...item, num: selectData[item.value]?.length || 0}));
      }else {
        const adPlacementId = ad_placement_id.filter(item=> (this.rootFormData.ad_placement_id || []).includes(item.value));
        return app_id.map(app=> {
          return {
            ...app,
            ad_placement_id: adPlacementId.map(item=> ({ ...item , num: selectData[`${app.value}_${item.value}`]?.length || 0}))
          }
        })
      }
     
      
    },
    ideaList() {
      const { app_id=[], ad_placement_id=[] } = this.rootFormDataOptions;
      const adPlacementId = ad_placement_id.filter(item=> (this.rootFormData.ad_placement_id || []).includes(item.value));
      const materialSelectData = this.selectOptionData.materialSelectData || {};
      // const rule = this.rootFormData.element_group_allocation_rules
      return app_id.map(app=> {
        return {
          ...app,
          ad_placement_id: adPlacementId.map(item=> ({ ...item , num: this.getMaterialNum(materialSelectData, app.value, item.value)}))
        }
      })

    }
  },
  mounted() {
    // setTimeout(() => {
    // 	this.$bus.$emit('app_id')
    // }, 1000)
  },
	methods: {
    getMaterialNum(data, app_id, display_type) {
      const total = _.reduce(Object.keys(data), (pre, key)=> {
        const [ appId, displayType ] = key.split('_');
          if (appId === app_id && displayType === display_type) {
            pre += (data[key] ||[]).length;
          }
         return pre;
        },0);
      return total;
    },
    handleOpenTargetedPackageDrawer() {
      if (!this.allowEdit) {
        this.$message.error('请先选择产品和版位');
        return;
      }
      const appList = this.rootFormDataOptions.app_id;
      const  [ target_list, bid_list, idea_list, defaultData ] = this.value || [];
      const onSubmit = (data, packageList, type) => {
        this.updatePackageList(data, type, packageList);
       
        vm.close()
      }
      const { vm  } = honorTargetedPackageDrawer({
        props: {
          appList,
          config: this.config,
		      account: this.rootFormData.account_id,
          objectiveType: this.rootFormData.objective_type,
          defaultData: _.cloneDeep(defaultData?.packageSelectData?.select || {}) ,
          selectType: this.addPackageType,
        },
        cbs: { onSubmit }
      })
    },
    updatePackageList(selectList, type, packageList) {
      const {  app_id = [] } = this.rootFormData;
      console.log(app_id, 'app_idapp_idapp_idapp_id');
      const data =  _.pickBy(selectList, (list, key)=> {
        return type === ADD_PACKAGE_TYPE.UNIFIED || app_id.includes(key) ;
      })
      const appList = this.rootFormDataOptions.app_id;
      const  [ target_list, bid_list, idea_list, defaultData ] = this.value || [];
      const targetList = appList.reduce((pre, cur)=> {
            const list =  (type === ADD_PACKAGE_TYPE.UNIFIED? ( data?.package_names || [] ) : (data[cur.value]) || []);
            const item = { 
              app_id: cur.value,
              list: list.map(item=> {
                return {
                  target_pkg_id: item,
                  // targeting_package_scope: '',//留着 暂时不用
                }
              })
            };
            pre.push(item);
            return pre;
        }, [])
        this.$emit('input', [
          targetList,
          bid_list,
          idea_list, 
          { 
            ...defaultData, 
            packageSelectData: { 
              list: _.mapValues(_.keyBy(packageList, 'value'), 'label') , 
              select: data,
              type
            } }
          ]
        );
    },
    // 更新转化数据
    updateBidList(selectList, addType) {
      const { ad_placement_id = [] , app_id = [] } = this.rootFormData;
      const data =  _.pickBy(selectList, (list, key)=> {
        const [ appId, sizeId ] = key.split('_');
        if(addType === ADD_TYPE.POSITION) {
          return ad_placement_id.includes(appId);
        }
        return app_id.includes(appId) && ad_placement_id.includes(sizeId);
      });
      const appList = this.rootFormDataOptions.app_id;
      const  [ target_list, bid_list, idea_list, defaultData ] = this.value || [];
        const isP = addType === ADD_TYPE.POSITION;//是否为按版位
        const bidList = appList.reduce((pre, cur)=> {
        const listMap = this.displayTypeList.map(item=> {
          const list =  (isP? data[item.value] : data[`${cur.value}_${item.value}`]) || [];
          return {
            app_id: cur.value,
            ad_placement_id: item.value,
            list: list.map(item=> {
              const { 
                way, price,deep, powerful, target, cost, deepCost , deepTarget,
				          powerfulName, coef_low, coef_tall
               } = item;
              return {
                pay_type: way,
                conv_type: target,
                ocpx_deep_type: deepTarget,
                ad_bid: price,
                ocpx_sbp: cost,
                ocpx_deep_price: deepCost,
                enhanced: +powerful,
                ocpx_deep: +deep,
                enhanced_conv_type: powerfulName,
                min_enhanced_ratio: coef_low,
                max_enhanced_ratio: coef_tall,
              }
            })
          }
        });
        pre.push(...listMap);
        return pre;
      }, [])
      this.$emit('input', [
        target_list,
        bidList,
        idea_list,
        {...defaultData, conversionSelectData: { type: addType, select: data }} 
      ]);
    },
    handleOpenConversionDrawer() {
      if (!this.allowEdit) {
        this.$message.error('请先选择产品和版位');
        return;
      }
      const appList = this.rootFormDataOptions.app_id;
      const  [ , , , defaultData ] = this.value || [];
      const onSubmit = (data, addType) => {
        this.updateBidList(data, addType);
        vm.close()
      }
      
      const { vm } = honorConversionDrawer({
        props: {
          appList,
          displayType: this.displayTypeList,
          config: this.config,
          defaultSelectData: _.cloneDeep(defaultData?.conversionSelectData?.select || {}),
          account: this.rootFormData.account_id,
          addType: this.addType,
        },
        cbs: { onSubmit }
      })
    },
    handleOpenMaterialDrawer() {
      if (!this.allowEdit) {
        this.$message.error('请先选择产品和版位');
        return;
      }
      // const appList = this.rootFormDataOptions.app_id;
      const  [ target_list, bid_list, idea_list, defaultData ] = this.value || [];
      const onSubmit = (data) => {
        this.updateMaterialList(data);
        // this.$emit('input', [
        //   target_list,
        //   bid_list,
        //   ideaList,
        //   {...defaultData, materialSelectData: data }
        // ]);
        vm.close()
      }
      const { vm } = honorMaterialDrawer({
        props: {
          appList: this.rootFormDataOptions.app_id,
          // appList,
          displayType: this.displayTypeList,
          // displayType,
          config: this.config,
          // config,
		      account: this.rootFormData.account_id,
          defaultData: _.cloneDeep(defaultData?.materialSelectData || {}),
          // rule: this.rootFormData.element_group_allocation_rules,
        },
        cbs: { onSubmit }
      })
    },
    updateMaterialList(selectList) {
      const { app_id, ad_placement_id } = this.rootFormData;
      const  [ target_list, bid_list, idea_list, defaultData ] = this.value || [];
      const data =  _.pickBy(selectList, (list, key)=> {
        const [ appId, sizeId ] = key.split('_');
        return app_id.includes(appId) && ad_placement_id.includes(sizeId);
      });
      console.log(selectList, data,  );
      const ideaList = Object.keys(data).map(key=> {
      	const [ app_id, ad_placement_id, ad_creative_spec_id ] = key.split('_');
        let list = data[key] || [];
        if(list.includes(null)) {
          list = list.filter(item=> item !== null);
        }
        const item = {
          app_id,
          ad_placement_id,
          ad_creative_spec_id,
          list: list.map(item=> {
            const data = _.omit(item, 'id');
          	return _.mapValues(data, (v, key)=> {
          		return {
                material_url: v.material_url,
                material_name: v.material_name,
              }
          	})
          })
        };
        return item;
      });
      this.$emit('input', [
        target_list,
        bid_list,
        ideaList,
        {...defaultData, materialSelectData: data }
      ]);
    },
    updataSelectData() {
      const  [ , , , defaultData ] = this.value || [];
      this.updateBidList(defaultData?.conversionSelectData?.select || {}, this.addType);
      this.$nextTick(()=> {
        const  [ , , , defaultData ] = this.value || [];
        const packageList = defaultData?.packageSelectData?.list || {};
        this.updatePackageList(
          defaultData?.packageSelectData?.select, 
          this.addPackageType, 
          Object.keys(packageList).map(key=> ({ value: key, label: packageList[key] }))
        );
        this.$nextTick(()=> {
          const  [,,, defaultData ] = this.value || [];
          this.updateMaterialList(defaultData?.materialSelectData || {});
        })
      })
      
     
      
    }
	},
  watch: {
  	"rootFormData.ad_placement_id"(n, o) {
      if(_.isEqual(n, o)) {
        return;
      }
      this.updataSelectData();
    },
  	'rootFormData.app_id'(n, o) {
      if(_.isEqual(n, o)) {
        return;
      };
      console.log(n, 'nnnnnnnnnnnnnnnnnnnnnnnnnnnn');
      this.updataSelectData();
  	}
  }
}
</script>

<style lang="scss" scoped>
.wk-modal-form {
    display: inline-flex;
    border: 1px solid #ccc;
    height: 550px;
    .item {
        width: 360px;
        height: 100%;
        display: flex;
        flex-direction: column;
        border-right: 1px solid #ccc;
        &:last-child {
            border-right: none;
        }
        .title {
            height: 40px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #ccc;
            padding: 0 20px;
            font-size: 14px;
            .option {
                color: #409EFF;
                cursor: pointer;
            }
        }
        .form-body {
            flex: 1;
            padding: 20px;
            height: 0;
            overflow: auto;
            .no-data {
                text-align: center;
                line-height: 100px;
                color: #adadad;
            }
        }
    }
    .list-data {
      &-item {
        line-height: 30px;
        .sub-item {
          padding-left: 20px;
        }
      }
    }
}
</style>